var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnDestroy, OnInit } from '@angular/core';
import { GeneralService } from '../../../../../_services/general.service';
import { PreviousUrlService } from '../../../../../_services/previous-url.service';
import { ReportsService } from '../../../../../_services/reports.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../../../_interceptors/api.service';
import { AuthenticationService } from '../../../../../_services/authentication.service';
import { PageTitleService } from '../../../../../_services/page-title.service';
import { environment } from '../../../../../../environments/environment';
import { MatTable } from '@angular/material/table';
import { MediaReplayService } from '../../../../../core/sidenav/mediareplay/media-replay.service';
import { ClientsService } from '../../../../../_services/clients.service';
var ReportsClosedBuildingsReportsListComponent = /** @class */ (function () {
    function ReportsClosedBuildingsReportsListComponent(reportsService, mediaReplayService, apiService, activatedRoute, authenticationService, previousUrlService, pageTitleService, clientsService, generalService) {
        this.reportsService = reportsService;
        this.mediaReplayService = mediaReplayService;
        this.apiService = apiService;
        this.activatedRoute = activatedRoute;
        this.authenticationService = authenticationService;
        this.previousUrlService = previousUrlService;
        this.pageTitleService = pageTitleService;
        this.clientsService = clientsService;
        this.generalService = generalService;
        this.routerTransition = true;
        this.totalItems = 0;
        this.currentPage = 0;
        this.searchString = '';
        this.isLoading = false;
        this.keepLoading = false;
        this.report_type = null;
        this.report_id = null;
        this.report_status = '/closed';
        this.building_id = null;
        this.buildingReports = [];
        this.reportEditable = false;
        this.user = null;
        this.hasBuildingMap = false;
        this.buildingMapUrl = null;
        this.mapMarkers = [];
        this._activatedRouteSubscription = null;
        this._authenticationSubscription = null;
        this._mediaSubscription = null;
        // table on tablet
        this.isTablet = false;
        this.displayedColumns = ['number', 'location_nr', 'measure_depth', 'measure_height', 'color_code', 'category_name', 'subcategory_name', 'shortcoming_types', 'shortcoming_actions', 'commands'];
        this.smallWidget = false;
    }
    ReportsClosedBuildingsReportsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._mediaSubscription = this.mediaReplayService.media$.subscribe(function (change) {
            _this.isTablet = (change.mqAlias === 'md' || change.mqAlias === 'lg');
        });
        this._activatedRouteSubscription = this.activatedRoute.params.subscribe(function (params) {
            _this.report_type = params['report_type'];
            _this.report_id = parseInt(params['report_id'], 10);
            _this.building_id = parseInt(params['building_id'], 10);
            _this.reportsService.getClosedReportBuildings(_this.report_type, _this.report_id, _this.building_id).then(function (data) {
                if (typeof data.data !== 'undefined') {
                    if (typeof data.data[0] !== 'undefined') {
                        if (typeof data.data[0].building_map_id !== 'undefined') {
                            if (data.data[0].building_map_id !== null) {
                                _this.reportsService.getClosedReports(_this.report_type, _this.report_id).then(function (report) {
                                    if (typeof report !== 'undefined') {
                                        _this.clientsService.getBuildingMap(report.client_id, data.data[0].building_map_id).then(function (buildingMap) {
                                            if (typeof buildingMap !== 'undefined') {
                                                _this.hasBuildingMap = true;
                                                _this.buildingMapUrl = buildingMap.map_url;
                                            }
                                        });
                                        _this.reportsService.getBuildingMapMarkers(_this.report_id, _this.building_id).then(function (markers) {
                                            _this.mapMarkers = markers;
                                        });
                                    }
                                });
                            }
                        }
                        if (_this.smallWidget === false) {
                            if (_this.report_type === 'warehouse') {
                                _this.pageTitleService.setTitle(data.data[0].name + ' | Gebouwen | ' + environment.webappName);
                            }
                            else {
                                _this.pageTitleService.setTitle(data.data[0].name + ' | Gebouwen - Trappen | ' + environment.webappName);
                            }
                            _this.pageTitleService.setPageTitle(data.data[0].name);
                        }
                    }
                }
            });
            _this._authenticationSubscription = _this.authenticationService.user.first().subscribe(function (user) {
                _this.user = user;
                _this.currentPage = 0;
                _this.getReportsBuildingReports(false);
            });
        });
    };
    ReportsClosedBuildingsReportsListComponent.prototype.ngOnDestroy = function () {
        if (this._mediaSubscription !== null) {
            this._mediaSubscription.unsubscribe();
        }
        if (this._activatedRouteSubscription !== null) {
            this._activatedRouteSubscription.unsubscribe();
        }
        if (this._authenticationSubscription !== null) {
            this._authenticationSubscription.unsubscribe();
        }
    };
    ReportsClosedBuildingsReportsListComponent.prototype.getReportsBuildingReports = function (append_data) {
        var _this = this;
        if (append_data === void 0) { append_data = true; }
        if (!this.isLoading || this.keepLoading) {
            this.isLoading = true;
            this.keepLoading = false;
            this.currentPage++;
            this.reportsService.getClosedReportBuildingReports(this.report_type, this.report_id, this.building_id, null, {
                start: (this.currentPage - 1) * this.generalService.itemsPerPage,
                length: this.generalService.itemsPerPage,
                'columns[0][search][value]': this.searchString
            }).then(function (data) {
                var _a, _b;
                if (typeof data !== 'undefined') {
                    if (typeof data.recordsTotal !== 'undefined') {
                        _this.totalItems = data.recordsTotal;
                    }
                    if (append_data === true) {
                        if (_this.isTablet && _this.report_type === 'warehouse') {
                            (_a = _this.buildingReports).push.apply(_a, __spread(_this.processReportData(data.data)));
                            _this.table.renderRows();
                        }
                        else {
                            (_b = _this.buildingReports).push.apply(_b, __spread(data.data));
                        }
                    }
                    else {
                        if (_this.isTablet && _this.report_type === 'warehouse') {
                            _this.buildingReports = _this.processReportData(data.data);
                            _this.table.renderRows();
                        }
                        else {
                            _this.buildingReports = data.data;
                        }
                    }
                }
                _this.isLoading = false;
            });
        }
    };
    ReportsClosedBuildingsReportsListComponent.prototype.processReportData = function (reportData) {
        var _this = this;
        reportData.forEach(function (report) {
            _this.reportsService.getShortcomingTypes(_this.report_type, report.lib_warehouse_element_id, report.lib_warehouse_subelement_id).then(function (data3) {
                if (typeof data3 !== 'undefined') {
                    if (typeof data3.data !== 'undefined') {
                        data3.data.forEach(function (data4) {
                            if (data4.active === true) {
                                if (report.warehouse_type_ids.indexOf(data4.id) !== -1) {
                                    var type = {
                                        id: data4.id,
                                        category_id: data4.category_id,
                                        subcategory_id: data4.subcategories,
                                        type_name: data4.type_name,
                                        amounts: data4.amounts,
                                        active: true,
                                        result: null
                                    };
                                    if (data4.amounts === true) {
                                        if (typeof report.warehouse_type_field_value !== 'undefined') {
                                            if (typeof report.warehouse_type_field_value[data4.id] !== 'undefined') {
                                                type.result = report.warehouse_type_field_value[data4.id];
                                            }
                                        }
                                    }
                                    if (typeof report.shortcoming_types === 'undefined') {
                                        report.shortcoming_types = [];
                                    }
                                    report.shortcoming_types.push(type);
                                }
                            }
                        });
                        _this.reportsService.getShortcomingActions(_this.report_type, report.lib_warehouse_element_id, report.lib_warehouse_subelement_id).then(function (data4) {
                            if (typeof data4 !== 'undefined') {
                                if (typeof data4.data !== 'undefined') {
                                    data4.data.forEach(function (data5) {
                                        if (typeof report.warehouse_action_ids !== 'undefined') {
                                            if (report.warehouse_action_ids !== null) {
                                                if (report.warehouse_action_ids.indexOf(data5.id) !== -1) {
                                                    if (typeof report.shortcoming_actions === 'undefined') {
                                                        report.shortcoming_actions = [];
                                                    }
                                                    report.shortcoming_actions.push({
                                                        id: data5.id,
                                                        category_id: data5.category_id,
                                                        subcategory_id: data5.subcategory_id,
                                                        action_name: data5.action_name,
                                                        active: true
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });
        });
        return reportData;
    };
    ReportsClosedBuildingsReportsListComponent.prototype.search = function ($event) {
        this.searchString = $event;
        this.currentPage = 0;
        this.getReportsBuildingReports(false);
    };
    ReportsClosedBuildingsReportsListComponent.prototype.showBuildingMap = function () {
        this.reportsService.showReportBuildingMap(this.buildingMapUrl, true, this.mapMarkers).then(function () {
        });
    };
    return ReportsClosedBuildingsReportsListComponent;
}());
export { ReportsClosedBuildingsReportsListComponent };
